<template>
  <div class="app-container">
    <div class="page-title">
      <h2>{{ $t("village.villages") }}</h2>
    </div>
    <el-card
      v-if="checkRole(['Admin'])"
      class="box-card filter-card just-for-admin"
    >
      <div slot="header" class="clearfix">
        <span>{{ $t("general.filter") }}</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="initSearch"
        >{{ $t("general.init") }}</el-button>
      </div>
      <div class="filter-container">
        <el-radio
          v-model="activeList"
          label="actives"
          border
          @change="getSubVillagesList('indexactive')"
        >{{ $t("general.F_actives") }}</el-radio>
        <el-radio
          v-model="activeList"
          label="desactives"
          border
          @change="getSubVillagesList('indexdesactive')"
        >{{ $t("general.F_desactives") }}</el-radio>
        <el-radio
          v-model="activeList"
          label="disponibles"
          border
          @change="handleFilterVillages"
        >{{ $t("general.disponibles") }}</el-radio>
        <el-radio
          v-model="activeList"
          label="corbeille"
          class="danger-radio"
          border
          @change="getSubVillagesList('indexinvisible')"
        >{{ $t("general.corbeille") }}</el-radio>
      </div>
    </el-card>

    <el-card class="box-card">
      <div class="filter-container">
        <el-input
          v-model="query.keyword"
          clearable
          :placeholder="$t('general.keyword')"
          class="wd-200 mr-15 filter-item"
          @keyup.enter.native="handleFilterVillages"
        />
        <el-select
          v-model="query.municipality_id"
          class="filter-item"
          filterable
          clearable
          :placeholder="$t('municipality.municipality')"
          @change="handleFilterVillages"
        >
          <el-option
            v-for="(municipality, index) in municipalities"
            :key="index"
            :label="municipality.name | uppercaseFirst"
            :value="municipality.id"
          />
        </el-select>
        <el-button
          v-waves
          class="mr-15 filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilterVillages"
        >
          {{ $t("general.search") }}
        </el-button>
        <el-button
          v-waves
          :loading="downloading"
          class="filter-item"
          type="primary"
          icon="el-icon-download"
          @click="handleDownload"
        >
          {{ $t("general.export") }}
        </el-button>
        <el-button
          v-waves
          class="filter-item"
          type="primary"
          icon="el-icon-upload"
          @click="handleImportVillages"
        >
          {{ $t('general.import') }}
        </el-button>
        <input
          ref="fileInput"
          type="file"
          style="display: none"
          accept=".xlsx, .xls"
          @change="onFileChange"
        >

        <el-button
          v-if="checkPermission(['create village'])"
          class="mr-15 filter-item"
          type="primary"
          icon="el-icon-plus"
          @click="handleCreateVillage"
        >
          {{ $t("general.add") }}
        </el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column align="center" :label="$t('general.reference')" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.ref }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('village.name')">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('municipality.municipality')" width="200">
          <template slot-scope="scope">
            <!-- <span>
              {{ municipalities.find((municipality) => municipality.id == scope.row.municipality_id)?.name??'' }}
            </span> -->
            <span>{{ scope.row.municipality.name }}</span>
          </template>
        </el-table-column>

        <el-table-column
          v-if="
            activeList != 'corbeille' && checkPermission(['activate village'])
          "
          align="center"
          :label="$t('general.status')"
          width="150"
        >
          <template slot-scope="scope">
            <el-switch
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_active"
              :disabled="!scope.row.is_visible"
              @change="setVillageStatus(scope.row.id, 'active')"
            />
          </template>
        </el-table-column>

        <el-table-column
          v-if="
            checkRole(['Admin']) && (activeList == 'corbeille' || query.keyword)
          "
          align="center"
          :label="$t('general.restaurer')"
          width="100"
        >
          <template slot-scope="scope">
            <el-switch
              v-if="!scope.row.is_visible"
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_visible"
              @change="setVillageStatus(scope.row.id, 'visible')"
            />
          </template>
        </el-table-column>
        <el-table-column
          v-if="checkPermission(['edit village', 'hide village', 'delete village'])"
          align="center"
          :label="
            1 == 1 ? $t('general.actions') : $t('general.suppressionDefinitive')
          "
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.is_visible && checkPermission(['edit village'])"
              type="primary"
              size="small"
              icon="el-icon-view"
              style="margin-right: 10px"
              @click="handleEditVillage(scope.row.id)"
            />
            <el-button
              v-if="checkPermission(['hide village', 'delete village'])"
              slot="reference"
              type="danger"
              size="small"
              icon="el-icon-delete"
              style="margin-right: 10px"
              @click="
                handleDeleteVillage(
                  scope.row.id,
                  scope.row.is_visible,
                  scope.row.name
                )
              "
            />
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-if="total > 0"
        :total="total"
        :page.sync="query.page"
        :limit.sync="query.limit"
        @pagination="getVillagesList"
      />

      <!-- ======= Village FORM ======= -->
      <el-dialog
        :title="
          editing
            ? $t('village.edit') + ' ' + currentVillage.name
            : $t('village.AddVillage')
        "
        :visible.sync="dialogCreateVillage"
        :before-close="handleCloseVillageCreateDraw"
        :loading="villageCreating"
        width="50%"
      >
        <div class="content-inputs">
          <el-form
            ref="villageForm"
            :rules="rules"
            :model="currentVillage"
            label-position="left"
          >
            <el-form-item
              :label="$t('municipality.selectMunicipalityTitle')"
              prop="municipality_id"
            >
              <el-select
                v-model="currentVillage.municipality_id"
                class="filter-item w-100"
                :placeholder="$t('municipality.municipality')"
              >
                <el-option
                  v-for="(municipality, index) in municipalities"
                  :key="index"
                  :label="municipality.name | uppercaseFirst"
                  :value="municipality.id"
                  :disabled="!municipality.is_active"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('village.name')" prop="name">
              <el-input v-model="currentVillage.name" />
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <div style="text-align: right">
            <el-button plain type="danger" @click="dialogCreateVillage = false">
              {{ $t("permission.cancel") }}
            </el-button>
            <el-button
              type="primary"
              :loading="villageCreating"
              @click="editing ? updateVillage() : createVillage()"
            >
              {{ villageCreating ? $t("general.saving") : $t("general.save") }}
            </el-button>
          </div>
        </span>
      </el-dialog>

      <!-- ======= END Village FORM ======= -->
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'; // Pagination
import Resource from '@/api/resource';
import waves from '@/directive/waves'; // Directives
import permission from '@/directive/permission'; //  directive Permission
import role from '@/directive/role'; // Directives Role
import checkPermission from '@/utils/permission'; // Vérification Permission
import checkRole from '@/utils/role'; // Vérification Roles
import moment from 'moment';
const villageResource = new Resource('villages');
const municipalityResource = new Resource('municipalities');
export default {
  name: 'VillagesList',
  components: { Pagination },
  directives: { waves, permission, role },
  data() {
    return {
      municipalities: [],
      list: null,
      total: 0,
      loading: false,
      downloading: false,
      villageCreating: false,
      editing: false,
      activeList: 'disponibles',
      query: {
        page: 1,
        limit: this.$limit,
        keyword: '',
      },
      currentVillage: {},
      dialogCreateVillage: false,
      currentVillageId: 0,
      rules: {
        name: [
          {
            required: true,
            message: this.$t('village.NameRequired'),
            trigger: 'blur',
          },
        ],
        municipality_id: [
          {
            required: true,
            message: this.$t('municipality.municipalityRequired'),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {},
  created() {
    this.getMunicipalitysList();
    this.resetNewVillage();
    this.getVillagesList();
  },
  methods: {
    checkPermission,
    checkRole,
    isEmptyArray(array) {
      if (typeof array !== 'undefined' && array.length === 0) {
        return true;
      }
    },
    handleCloseVillageCreateDraw(done) {
      this.$confirm(this.$t('general.closingWarningText'))
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    cancelVillageForm() {
      this.$refs.VillageCreationDrawer.closeDrawer();
    },
    initSearch() {
      this.query = {
        page: 1,
        limit: this.$limit,
        keyword: '',
      };
      this.activeList = 'disponibles';
      this.handleFilterVillages();
    },
    async getVillagesList() {
      this.loading = true;
      const { limit, page } = this.query;
      const { data, meta } = await villageResource.list(this.query);
      this.list = data;
      this.list.forEach((element, index) => {
        element['index'] = (page - 1) * limit + index + 1;
      });
      this.total = meta.total;
      this.loading = false;
    },
    async getSubVillagesList(subUrl) {
      this.loading = true;
      const { data } = await villageResource.sublist('/' + subUrl, this.query);
      this.list = data;
      this.loading = false;
    },
    handleFilterVillages() {
      this.query.page = 1;
      this.getVillagesList();
    },
    handleCreateVillage() {
      this.editing = false;
      this.resetNewVillage();
      this.dialogCreateVillage = true;
      this.$nextTick(() => {
        this.$refs['villageForm'].clearValidate();
      });
    },
    handleEditVillage(id) {
      this.editing = true;
      this.resetNewVillage();
      this.currentVillage = this.list.find((abonne) => abonne.id === id);
      this.dialogCreateVillage = true;
      this.$nextTick(() => {
        this.$refs['villageForm'].clearValidate();
      });
    },
    async setVillageStatus(id, type) {
      const data = await villageResource.get('toogle_' + type + '/' + id);
      if (data.success) {
        this.$message({
          type: 'success',
          message: this.$t('general.statusUpdated'),
        });
        this.initSearch();
      } else {
        this.$message({
          type: 'danger',
          message: this.$t('general.statusUpdateError'),
        });
      }
    },
    handleDeleteVillage(id, visible, name) {
      this.$confirm(
        this.$t('village.deleteWarn') +
          ' ' +
          name +
          '. ' +
          this.$t('general.deleteContinue'),
        'Warning',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: this.$t('general.cancel'),
          type: 'warning',
        }
      )
        .then(() => {
          if (
            !visible &&
            (checkRole(['Admin']) || checkPermission(['delete village']))
          ) {
            this.$swal({
              title: this.$t('general.SureQuestion'),
              text: this.$t('general.irrversibleMessage'),
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: this.$t('general.ouiSupprimer'),
            }).then((result) => {
              if (result.isConfirmed) {
                villageResource
                  .destroy(id)
                  .then((response) => {
                    this.$message({
                      type: 'success',
                      message: this.$t('village.suppressionEffectue'),
                    });
                    this.initSearch();
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }
            });
          } else {
            this.setVillageStatus(id, 'visible');
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general.suppressionAnnule'),
          });
        });
    },
    createVillage() {
      this.$refs['villageForm'].validate((valid) => {
        if (valid) {
          this.villageCreating = true;
          villageResource
            .store(this.currentVillage)
            .then(async(response) => {
              this.$message({
                message:
                  this.$t('village.NewVillage') +
                  ' ' +
                  this.currentVillage.name +
                  ' ' +
                  this.$t('village.iscreatedSuccessfully'),
                type: 'success',
                duration: 5 * 1000,
              });
              this.currentVillageId = response.data.id;
              this.resetNewVillage();
              this.dialogCreateVillage = false;
              this.handleFilterVillages();
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              this.villageCreating = false;
            });
        } else {
          this.$message({
            type: 'danger',
            message: this.$t('general.invalidForm'),
          });
          return false;
        }
      });
    },
    updateVillage() {
      this.$refs['villageForm'].validate((valid) => {
        if (valid) {
          this.villageCreating = true;
          villageResource
            .update(this.currentVillage.id, this.currentVillage)
            .then((response) => {
              this.resetNewVillage();
              this.handleFilterVillages();
              this.$message({
                message: this.$t('village.isupdatedSuccessfully'),
                type: 'success',
                duration: 5 * 1000,
              });
              this.dialogCreateVillage = false;
              this.editing = false;
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              this.villageCreating = false;
            });
        } else {
          this.$message({
            type: 'danger',
            message: this.$t('general.invalidForm'),
          });
          return false;
        }
      });
    },
    resetNewVillage() {
      this.currentVillage = {
        name: '',
      };
    },
    async getMunicipalitysList() {
      this.loading = true;
      const { limit, page } = this.query;
      const { data, meta } = await municipalityResource.list(this.query);
      this.municipalities = data;
      this.municipalities.forEach((element, index) => {
        element['index'] = (page - 1) * limit + index + 1;
      });
      this.total = meta.total;
      this.loading = false;
    },
    handleDownload() {
      this.downloading = true;
      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = [
          'ID',
          this.$t('village.name'),
          this.$t('municipality.municipality'),
        ];
        const filterVal = ['id', 'name', 'municipality_id'];
        const data = this.formatJson(filterVal, this.list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename:
            'Villages list GEOSANTE_' + moment().format('DD-MM-YYYY_hh-mm'),
        });
        this.downloading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    // Importation
    handleImportVillages() {
      // Ouvre le sélecteur de fichier
      this.$refs.fileInput.click();
    },

    async onFileChange(event) {
      console.log('onFileChange');
      const file = event.target.files[0];
      if (!file) {
        return;
      }

      try {
        // Utilisez XLSX pour lire le fichier Excel
        const XLSX = await import('xlsx');
        const reader = new FileReader();

        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });

          // Supposons que les données sont dans la première feuille
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          // Convertir les données en JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet, {
            header: ['code', 'name', 'municipality'],
            range: 1,
          });

          // Valider et envoyer les données au backend
          this.uploadVillages(jsonData);
        };

        reader.readAsArrayBuffer(file);
      } catch (error) {
        console.error('Erreur lors de la lecture du fichier Excel:', error);
        this.$message.error(this.$t('general.importError'));
      }
    },

    async uploadVillages(villages) {
      try {
        // Envoyer les données au backend
        const response = await villageResource.substore(
          '/import',
          villages
        );

        if (response.success) {
          this.$message.success(this.$t('village.importSuccess'));
          this.getVillagesList(); // Rafraîchir la liste des départements
        } else {
          this.$message.error(this.$t('village.importError'));
        }
      } catch (error) {
        console.error('Erreur lors de l\'importation des municipalités:', error);
        this.$message.error(this.$t('village.importError'));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.half-right {
  width: 70% !important;
  float: none !important;
  text-align: left !important;
  padding: 10px;
}
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.dialog-footer {
  text-align: left;
  padding-top: 0;
  margin-left: 150px;
}
.app-container {
  flex: 1;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  .block {
    float: left;
    min-width: 250px;
  }
  .clear-left {
    clear: left;
  }
}
</style>
